export class EquipmentLog {


  handOut: string;
  takeBack: string;

  note: string;

  constructor(data?: any) {
    if (data) {
      this.handOut = data.handOut;
      this.takeBack = data.takeBack;
      this.note = data.note;
    }
  }
}

export class EquipmentIdentifier {
	equipmentId: string;
	equipmentTypeId: string;

  constructor(data?: any) {
    if (data) {
      this.equipmentId = data.equipmentId;
      this.equipmentTypeId = data.equipmentTypeId;
    }
  }
}

export enum EquipmentType {
  SmartPhone = 'SMART_PHONE',
  SupplementaryEquipment = 'SUPPLEMENTARY_EQUIPMENT',
  Pager = 'PAGER',
}
